/**
 * PDP Swatches - SOLUCIÓN SIMPLE
 * Reutiliza la lógica EXACTA de collection-swatches-more-colores-fix-work.js
 */

// Solo ejecutar en páginas de producto
if (document.body.classList.contains('template-product') || 
    window.location.pathname.includes('/products/')) {
  
  console.log('[PDP Simple] Initializing...');
  
  // 📊 Métricas de rendimiento
  const startTime = performance.now();

  // Variables globales (igual que collection JS)
  var combinedarray;
  var handleToProductMap = {};
  const DEBUG = window.location.search.includes('debug=true') || window.location.search.includes('swatch_debug=true');
  
  // Crear swatchurl si no existe (solo disponible en collections)
  if (typeof window.swatchurl === 'undefined') {
    window.swatchurl = 'https://flagandanthem.com/cdn/shop/files/';
  }

  // Función EXACTA del collection JS para obtener metafields de imágenes
  const getSwatchesImages = () => {
    const urls = [
      "/collections/all/products?page=1&limit=1000",
      "/collections/all/products?page=2&limit=1000",
      "/collections/all/products?page=3&limit=1000",
      "/collections/all/products?page=4&limit=1000",
      "/collections/all/products?page=5&limit=1000",
      "/collections/all/products?page=6&limit=1000",
      "/collections/all/products?page=7&limit=1000",
      "/collections/all/products?page=8&limit=1000",
    ];

    const dataImages = [];

    return Promise.all(
      urls.map((url) =>
        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const elements = doc.querySelectorAll(".json-product-images");

            elements.forEach((el) => {
              const dataAttr = el.getAttribute("data-image");
              if (dataAttr) {
                try {
                  const jsonData = JSON.parse(dataAttr);
                  dataImages.push(...jsonData);
                } catch (e) {
                  console.log("Error parsing swatch images JSON:", e);
                }
              }
            });
          })
          .catch((err) => {
            console.log("Error fetching swatch images:", err);
          })
      )
    ).then(() => dataImages);
  };

  // Función EXACTA del collection JS
  function createPDPSwatches() {
    const urls = [
      "/collections/all/products.json?page=1&limit=1000",
      "/collections/all/products.json?page=2&limit=1000",
      "/collections/all/products.json?page=3&limit=1000",
      "/collections/all/products.json?page=4&limit=1000",
      "/collections/all/products.json?page=5&limit=1000",
      "/collections/all/products.json?page=6&limit=1000",
      "/collections/all/products.json?page=7&limit=1000",
      "/collections/all/products.json?page=8&limit=1000",
    ];

    Promise.all(
      urls.map((url) => fetch(url).then((response) => response.json()))
    ).then((data) => {
      combinedarray = [];
      data.forEach(function(page) {
        if (page.products && page.products.length > 0) {
          combinedarray = combinedarray.concat(page.products);
        }
      });

      console.log('[PDP Simple] Total products loaded:', combinedarray.length);
      // Construir mapa handle -> producto para búsquedas rápidas
      handleToProductMap = {};
      try {
        combinedarray.forEach(p => { if (p && p.handle) handleToProductMap[p.handle] = p; });
      } catch (e) {}
      assignPDPSwatches(combinedarray);
    });
  }

  // Función adaptada para PDP (basada en assignswatches del collection JS)
  function assignPDPSwatches(combinedarray) {
    // Obtener información del producto actual
    const currentProductTitle = window.currentProductInfo?.title || 
                               document.querySelector('h1')?.textContent?.trim() || '';
    
    if (!currentProductTitle) {
      console.log('[PDP Simple] No product title found');
      return;
    }

    console.log('[PDP Simple] Processing for product:', currentProductTitle);

    const swatchContainer = document.querySelector('.ajax-swatches-container');
    if (!swatchContainer) {
      console.log('[PDP Simple] No swatch container found');
      return;
    }

    let swatchesHTML = '';
    let swatchCount = 0;
    const processedColors = new Set();

    // Determinar si es Big/Tall
    const isBigTall = currentProductTitle.toLowerCase().includes('big') && 
                     currentProductTitle.toLowerCase().includes('tall');

    combinedarray.forEach((product) => {
      const productTitle = product.title.toLowerCase();
      
      // Filtro Big/Tall
      if (isBigTall) {
        if (!(productTitle.includes('big') || productTitle.includes('tall'))) {
          return;
        }
      } else {
        if (productTitle.includes('big') || productTitle.includes('tall')) {
          return;
        }
      }

      // Matching de título (ESTRICTO: solo coincidencia exacta del nombre base)
      const currentBase = currentProductTitle.split(' - ')[0].trim().toLowerCase();
      const productBase = product.title.split(' - ')[0].trim().toLowerCase();
      
      const isMatch = currentBase === productBase;

      if (isMatch) {
        swatchCount++;
        
        // Procesar variantes (LÓGICA EXACTA del collection JS)
        if (product.variants && product.variants.length > 0) {
          const variant = product.variants[0];
          const productid = product.id;
          const producthandle = product.handle;
          const image = product.images[0]?.src || '';
          const variantTitle = variant.title;
          const colorsplit = variantTitle.split(" / ");
          const color = colorsplit[0];
          const colorKey = `${product.id}-${color}`;

          // Evitar duplicados
          if (processedColors.has(colorKey)) {
            return;
          }
          processedColors.add(colorKey);

          const colorhandleized = color
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/\//g, "-");

          // LÓGICA EXACTA del collection JS para imágenes
          const swatches_data = window.swatchesImages || [];
          const dataImagesExt = swatches_data.find(
            (item) => item.id == productid
          );

          // LÓGICA EXACTA del collection-swatches.js  
          const swatchUpdatedBG = dataImagesExt?.swatch_image
            ? dataImagesExt.swatch_image
            : `${window.swatchurl}${colorhandleized}.png`;
          
          // Generar HTML (ESTRUCTURA EXACTA del collection JS)
          const swatchHTML = `
            <a reference="${productid}" href="/products/${producthandle}" class="swatch-link">
              <span data-variant-color="${color}" data-url="/products/${producthandle}" 
                class="variantcolor collectionswatch color-swatch color-swatch-collection color-swatch--small color-swatch--${colorhandleized} color-swatch--with-image" 
                data-tooltip="${color}" 
                data-variant-image="${image}&width=500" 
                style="background-image: url('${swatchUpdatedBG}'); background-color: ${color};" 
                data-uw-styling-context="true">
                <span class="visually-hidden" data-uw-styling-context="true">${color}</span>
              </span>
            </a>`;

          swatchesHTML += swatchHTML;
        }
      }
    });

    // Ocultar spinner
    const loader = document.getElementById('ajaxSwatchesLoader');
    if (loader) {
      loader.style.display = 'none';
    }

    // Solo mostrar si hay 2+ swatches
    if (swatchCount >= 2 && swatchesHTML.length > 0) {
      swatchContainer.innerHTML = swatchesHTML;
      swatchContainer.style.display = 'flex';
      
      // Aplicar disponibilidad por talla
      try {
        const selectedSize = getSelectedSize();
        updateAjaxSwatchesAvailability(selectedSize);
        initSizeChangeListeners();
      } catch (e) {}
      
      console.log(`[PDP Simple] ✅ Swatches inserted successfully`);
    } else {
      // Ocultar toda la sección
      const wrapper = document.querySelector('.ajax-swatches-wrapper');
      if (wrapper) {
        wrapper.style.display = 'none';
      }
    }
  }

  // ===================== LÓGICA: Tachado por talla (solo AJAX) =====================
  function getSelectedSize() {
    const sizeRadio = document.querySelector('input[data-variant-input][name*="Size" i]:checked');
    if (sizeRadio) return sizeRadio.value;
    const sizeSelect = document.querySelector('select[name*="Size" i]');
    if (sizeSelect && sizeSelect.value) return sizeSelect.value;
    return null;
  }

  function getOptionIndex(product, keyword) {
    if (!product || !product.options) return -1;
    let idx = -1;
    product.options.forEach((opt, i) => {
      const name = typeof opt === 'string' ? opt : (opt && opt.name) ? opt.name : '';
      if (name && name.toLowerCase().includes(keyword)) idx = i;
    });
    return idx;
  }

  function getVariantValueByIndex(variant, index) {
    if (!variant || index < 0) return undefined;
    if (Array.isArray(variant.options)) {
      return variant.options[index];
    }
    const key = `option${index + 1}`;
    return variant[key];
  }

  function isSizeAvailableForColor(product, colorIndex, sizeIndex, colorValue, sizeValue) {
    if (!product || !Array.isArray(product.variants)) return false;
    for (const v of product.variants) {
      const vColor = getVariantValueByIndex(v, colorIndex);
      const vSize = getVariantValueByIndex(v, sizeIndex);
      if (v.available && vColor === colorValue && vSize === sizeValue) {
        return true;
      }
    }
    return false;
  }

  function updateAjaxSwatchesAvailability(selectedSize) {
    const container = document.querySelector('.ajax-swatches-container');
    if (!container) return;
    const links = container.querySelectorAll('a.swatch-link');
    
    links.forEach((a) => {
      let handle = '';
      try {
        const href = a.getAttribute('href') || '';
        const parts = href.split('/products/');
        if (parts.length > 1) handle = parts[1].split('?')[0].split('#')[0];
      } catch (e) {}
      
      const span = a.querySelector('.color-swatch');
      const colorValue = span ? (span.getAttribute('data-variant-color') || '').trim() : '';
      const product = handleToProductMap[handle] || (combinedarray || []).find(p => p.handle === handle);
      
      if (!product || !colorValue || !selectedSize) {
        a.classList.remove('swatch-unavailable');
        a.removeAttribute('aria-disabled');
        return;
      }
      
      const colorIdx = getOptionIndex(product, 'color');
      const sizeIdx = getOptionIndex(product, 'size');
      const available = isSizeAvailableForColor(product, colorIdx, sizeIdx, colorValue, selectedSize);
      
      if (!available) {
        a.classList.add('swatch-unavailable');
        a.setAttribute('aria-disabled', 'true');
      } else {
        a.classList.remove('swatch-unavailable');
        a.removeAttribute('aria-disabled');
      }
    });
  }

  function initSizeChangeListeners() {
    const handler = () => {
      setTimeout(() => {
        const size = getSelectedSize();
        updateAjaxSwatchesAvailability(size);
      }, 50);
    };
    document.querySelectorAll('input[data-variant-input][name*="Size" i]').forEach(el => el.addEventListener('change', handler));
    document.querySelectorAll('input[type="radio"]').forEach(el => el.addEventListener('change', handler));
    document.querySelectorAll('select[name*="Size" i]').forEach(el => el.addEventListener('change', handler));
  }

  // 🚀 CACHE INTELIGENTE: Máxima velocidad cuando viene de collection
  function initializePDPSwatches() {
    if (window.swatchesImages && 
        Array.isArray(window.swatchesImages) && 
        window.swatchesImages.length > 0) {
      
      console.log('[PDP Simple] ⚡ CACHE HIT! Using existing swatch images');
      createPDPSwatches();
      
    } else {
      console.log('[PDP Simple] 🔄 Cache miss - Loading swatch images...');
      
      const metafieldsPromise = getSwatchesImages();
      
      metafieldsPromise.then((images) => {
        window.swatchesImages = images;
        createPDPSwatches();
      }).catch((error) => {
        console.log('[PDP Simple] ❌ Error loading swatch images:', error);
        window.swatchesImages = [];
        createPDPSwatches();
      });
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePDPSwatches);
  } else {
    initializePDPSwatches();
  }
}